module.exports = "/_next/static/images/guarantee_revisi_en-acadd7f3b83b24fe879360b21a983e17.webp";